/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { white } = colors;

const tabs = {
  styleOverrides: {
    root: {
      position: "relative",
      // TMS Control Tower sekme seçicisi: beyaz zemin, ince kenarlık, lacivert seçili hap
      backgroundColor: white.main,
      border: "1px solid rgba(15, 23, 42, 0.12)",
      borderRadius: "10px",
      minHeight: "unset",
      padding: pxToRem(4),
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
    },

    fixed: {
      overflow: "unset !important",
      overflowX: "unset !important",
    },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "100%",
      },
    },

    indicator: {
      height: "100%",
      borderRadius: "7px",
      backgroundColor: "#0B1F3A",
      boxShadow: "none",
      transition: "all 500ms ease",
    },
  },
};

export default tabs;
